import clsx from "clsx";
import {
  MagnifyingGlassIcon,
  ViewColumnsIcon,
  Bars3Icon,
} from "@heroicons/react/24/outline";
import type { ProjectsFiltersProps } from "./projectsFilters.types";

export function ProjectsFilters({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  viewMode,
  onViewModeChange,
}: ProjectsFiltersProps) {
  return (
    <div className="bg-white rounded-xl p-6 border border-primary-100 shadow-raro">
      <div className="flex flex-col sm:flex-row gap-4">
        {/* Search */}
        <div className="flex-1">
          <div className="relative">
            <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-raro-gray-400" />
            <input
              type="text"
              placeholder="Buscar projetos..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-3 border border-raro-gray-300 rounded-xl font-montserrat focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
            />
          </div>
        </div>

        {/* Status Filter */}
        <select
          value={statusFilter}
          onChange={(e) => onStatusChange(e.target.value as typeof statusFilter)}
          className="min-w-0 w-48 px-4 py-3 border border-raro-gray-300 rounded-xl font-montserrat focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
        >
          <option value="all">Todos os Status</option>
          <option value="draft">Rascunho</option>
          <option value="planning">Planejamento</option>
          <option value="in_progress">Em Andamento</option>
          <option value="completed">Concluído</option>
          <option value="cancelled">Cancelado</option>
        </select>

        {/* View Toggle */}
        <div className="flex rounded-xl border border-raro-gray-300 overflow-hidden">
          <button
            onClick={() => onViewModeChange("grid")}
            className={clsx(
              "p-3 transition-all",
              viewMode === "grid"
                ? "bg-primary-500 text-white"
                : "bg-white text-raro-gray-600 hover:bg-raro-gray-50"
            )}
          >
            <ViewColumnsIcon className="w-5 h-5" />
          </button>
          <button
            onClick={() => onViewModeChange("list")}
            className={clsx(
              "p-3 transition-all",
              viewMode === "list"
                ? "bg-primary-500 text-white"
                : "bg-white text-raro-gray-600 hover:bg-raro-gray-50"
            )}
          >
            <Bars3Icon className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}